<template>
  <div class="product-attributes">
      <div v-for="attribute in attributes" :key="attribute.key">
        <span>{{attribute.label}}: </span><span v-for="(option, index) in attribute['options']" :key="attribute.key + index">{{option.name}}</span>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ProductAttributes',
  props: {
    attributes: Array
  },
};
</script>
